import {
	find,
	findAll,
	addClass,
	removeClass,
	onReady,
	onResize,
	onScroll,
	hasClass
} from "../../../../modules/vegas/js/util";

let lastScrollTop = 0;

function init() {
	let header = find('header'),
		sticky = find('.header-sticky', header),
		scroll = document.documentElement.scrollTop,
		body = document.body,
		stickyArea = [...findAll('.sticky-area')],
		minStartScroll = header?.getBoundingClientRect().height || 0,
		search = document.querySelector('.search-advanced--wrapper');


	if (scroll > minStartScroll) {
		addClass(body, 'header--is-scroll');

		if (scroll > lastScrollTop) {
			removeClass(sticky, 'fixed');
			removeClass(body, 'header--is-fixed');

			if (stickyArea.length) {
				stickyArea.forEach((_sticky) => removeClass(_sticky, 'fixed'));
			}
		} else {
			addClass(sticky, 'fixed');
			addClass(body, 'header--is-fixed');

			if (stickyArea.length) {
				stickyArea.forEach((_sticky) => addClass(_sticky, 'fixed'));
			}
		}

		lastScrollTop = scroll;
	} else if (scroll < minStartScroll) {
		removeClass(sticky, 'fixed')
		removeClass(body, 'header--is-scroll header--is-fixed');
	}

	if (search) {
		if (!hasClass(body, 'header--is-fixed')) {
			search.style.top = (minStartScroll - scroll) + 'px';
		} else {
			search.style.top = 80 + 'px';
		}
	}
}

onReady(init);
onScroll(init);
onResize(init);
